/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
import { Api } from '@/services/Api'

export default {
  getBlockList(plantId) {
    return Api().get(`/api/v1.0/block_list/${plantId}`)
  },
  getDeviceBlockList(plantId, device) {
    return Api().get(`/api/v1.0/block_list/${plantId}/${device}`)
  },
  getDeviceList(plantId) {
    return Api().get(`/api/v1.0/detail-device-list/${plantId}`)
  },
  getWsOrInvRoomList(plantId, device, blockId) {
    return Api().get(`/api/v1.0/detail-device-list/${plantId}/${device}/${blockId}`)
  },
  getInverterList(plantId, device, blockId, invRoom) {
    return Api().get(`/api/v1.0/detail-device-list/${plantId}/${device}/${blockId}/${invRoom}`)
  },
  getScbList(plantId, device, blockId, invRoom, invId) {
    return Api().get(`/api/v1.0/detail-device-list/${plantId}/${device}/${blockId}/${invRoom}/${invId}`)
  },
  getIdList(plantId, device, type, idList) {
    return Api().get(`/api/v1.0/detail-device-list/${plantId}/${device}/${type}/${idList}`)
  },
  getPlantGenerationHours(plantId, date) {
    return Api().get(`/api/v1.0/generation-hours/${plantId}/${date}`)
  },
  getLastUpdateTime() {
    return Api().get('/api/v1.0/last-update')
  }
}
